import { useEffect, useRef, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const About = () => {
  const aboutRef = useRef<HTMLDivElement | null>(null);
  const [showFixedContact, setShowFixedContact] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!aboutRef.current) return;

      const aboutTop = aboutRef.current.getBoundingClientRect().top;

      setShowFixedContact(window.scrollY >= aboutTop);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      id="about"
      ref={aboutRef}
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36 text-center"
    >
      <div className="relative w-fit h-fit mx-auto mb-14">
        <img
          src="/images/logo.png"
          alt="장인배관 로고"
          width={247}
          height={58}
          className="!relative w-full h-auto max-w-32"
        />
      </div>
      <p className="text-black font-light text-xl lg:text-4xl">
        <span className="text-primary">누수</span>{" "}
        아직도&nbsp;고민만&nbsp;하고&nbsp;계신가요?
      </p>
      <div
        data-aos="fade-up"
        className="relative w-fit h-fit mx-auto my-9 lg:my-14"
      >
        <img
          src="/images/about.png"
          alt="장인배관 누수 해결 안내 문구"
          className="!relative w-auto h-full max-h-12 lg:max-h-28"
        />
      </div>
      <p
        data-aos="fade-up"
        className="font-light text-xl lg:text-4xl text-primary"
      >
        문의접수&nbsp;신청하는데&nbsp;10초!
        <br />
        전화상담&nbsp;진행하는&nbsp;시간&nbsp;평균&nbsp;3분!
        <br />
        <br />
        장인배관에&nbsp;맡겨주시면 책임지고&nbsp;해결해드립니다.
      </p>

      <AboutContact isFixed={showFixedContact} />
    </div>
  );
};

export default About;

export const AboutContact = ({ isFixed }: { isFixed: boolean }) => {
  const [phone, setPhone] = useState<string>("");

  const handlerPostContact = async () => {
    if (!phone) {
      Swal.fire({
        title: "연락처를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    await axios
      .post("/api/contact/quick", {
        name: "간편문의",
        phone: phone,
        address: "",
        type: "",
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <div
      className={` hidden 
        lg:fixed left-1/2 bottom-4 -translate-x-1/2 z-50
        w-[calc(100%-1.5rem)] max-w-screen-xl
        bg-gradient-to-t from-[#2b78fd] to-primary
        p-3 lg:pㅗㅑ-6 rounded-3xl
        shadow-2xl
        transition-all duration-500 ease-out
        ${
          isFixed
            ? "opacity-100 translate-y-0 scale-100 pointer-events-auto"
            : "opacity-0 translate-y-6 scale-[0.98] pointer-events-none"
        }
      `}
    >
      <div className="flex justify-between items-center gap-3">
        <div
          onClick={() => (window.location.href = "tel:010-3409-5404")}
          className="relative w-fit h-fit cursor-pointer"
        >
          <img
            src="/images/rightNum.png"
            alt="장인배관 전화번호 010-3409-5404"
            className="hidden lg:inline-block !relative w-auto h-full max-h-16"
          />
        </div>

        <div className="relative w-full h-fit max-w-96 text-black">
          <input
            type="text"
            placeholder="전화번호를 입력하세요"
            value={phone}
            className="!h-16 !rounded-lg shadow-lg shadow-[rgba(0,0,0,0.4)] text-center lg:text-xl placeholder:text-black"
            id="phone1"
            onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ""))}
          />
        </div>

        <div className="relative w-fit h-fit border-l border-white pl-6">
          <button type="button" onClick={handlerPostContact}>
            <img
              src="/images/contactBtn.png"
              alt="장인배관 문의 접수 버튼"
              className="!relative w-auto h-full max-h-10"
            />
          </button>

          <div className="flex justify-start items-center gap-1 text-white">
            <input
              type="checkbox"
              name="privacy"
              id="privacy"
              defaultChecked
              checked={true}
              readOnly
              className="!w-3 !h-3"
            />
            <label htmlFor="privacy">
              <p className="text-[10px] lg:text-xs">
                개인정보처리방침&nbsp;동의
              </p>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
